import { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { InvitationDisplay } from "../../components/invitation";
import { useSearchParams } from "react-router-dom";
import { FetchingStatus } from "../../shared/types";
import { updateMatcherDeclineInvitation } from "../../services/services";

const Decline = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [matcherInvitationDeclineFS, setMatcherInvitationDeclineFS] =
    useState<FetchingStatus>("never");

  useEffect(() => {
    updateMatcherDeclineInvitation({
      token,
      matcherInvitationDeclineFS,
      setMatcherInvitationDeclineFS,
    });
  }, [token]);

  const isLinkExpired = !token || matcherInvitationDeclineFS === "errored";
  const isInvitationDeclined = matcherInvitationDeclineFS === "done";

  if (
    matcherInvitationDeclineFS === "never" ||
    matcherInvitationDeclineFS === "ongoing"
  ) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <InvitationDisplay
      isInvitationAccepted={!isInvitationDeclined}
      isLinkExpired={isLinkExpired}
    />
  );
};

export default Decline;
